/*!
 * LANA3D v0.3.0
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As LANA3D depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

LANA3D.Editor = function () {
    this.signals = {
        objectSelected: undefined,
        objectChanged: undefined
    };
};

LANA3D.Editor.prototype = {
    /**
     * Gets scene
     * @returns {LANA3D.Scene}
     */
    getScene: function () {},

     /**
     * Gets asset type
     * @param {LANA3D.Scene}
     */
    setScene: function (scene) {},

    addNode: function(node) {},
    selectNode: function(node) {},
    deleteNode: function(node) {},
    notifySelectedNodeUpdated: function() {},
    getDomElement: function() {},
    resize: function() {},
    clearScene: function() {}
};

LANA3D.Editor.create = function() {};

(function (LANA3D) {
    (function (ThreeImpl) {

        // Used in Viewport.Info
        Number.prototype.format = function (){
            return this.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        };

        function EditorImpl(parameters) {
            LANA3D.Editor.apply ( this, arguments );
            var self = this;

            this._editor =  new Editor();
            this._viewport = new Viewport(this._editor);
            //editor.setTheme("css/light.css");

            this._editor.signals.objectAdded.active = false;

            //add ambient light
            var color = 0xFFFFFF;
            var light = new THREE.AmbientLight( color );
            light.name = "ambientLight 1";
            this._editor.addObject( light );

            //Create the RootNode
            this._scene = LANA3D.NodeManager.getInstance().createNode('scene');
            this._scene.setName("RootNode");

            this._editor.addObject(this._scene.getInternal());

            this._editor.signals.objectAdded.active = true;

            this.signals.objectSelected = new signals.Signal();
            this._editor.signals.objectSelected.add(function(object){
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectSelected.dispatch(node);
            });

            this.signals.objectChanged = new signals.Signal();
            this._editor.signals.objectChanged.add(function(object){
                var node = object ? LANA3D.NodeManager.getInstance().getNodeFromInternal(object) : object;
                self.signals.objectChanged.dispatch(node);
            });

            var clock = new THREE.Clock();

            var animate = function() {
                requestAnimationFrame( animate );

                var delta = clock.getDelta();

                if (LANA3D.AnimationManager.updateAnimations(delta)) {
                    
                    for ( var i = 0, l = self._editor.sceneHelpers.children.length; i < l; i ++ ) {

                        var helper = self._editor.sceneHelpers.children[ i ];

                        if ( helper instanceof THREE.SkeletonHelper ) {
                            helper.update();
                        }
                    }
                    
                    self._editor.signals.sceneGraphChanged.dispatch();
                }
            }

            animate();

        }
        EditorImpl.prototype = Object.create( LANA3D.Editor.prototype);

        EditorImpl.prototype.getScene = function () {
            return this._scene;
        };
        EditorImpl.prototype.setScene = function (scene) {
            if(scene instanceof LANA3D.Node) {
                this._editor.removeObject(this._scene.getInternal());
                this._editor.addObject(scene.getInternal());
                this._scene = scene;
            }
        };

        EditorImpl.prototype.addNode = function (node) {
            this._editor.addObject(node.getInternal());
            this._editor.moveObject(node.getInternal(), this._scene.getInternal());
        };
        EditorImpl.prototype.selectNode = function (node) {
            this._editor.select(node instanceof LANA3D.Node ? node.getInternal() : node);
        };
        EditorImpl.prototype.deleteNode = function (node) {
            if (node instanceof LANA3D.Node) {
                this._editor.removeObject(node.getInternal());
                LANA3D.NodeManager.destroyNode(node);
            }
        };

        EditorImpl.prototype.getDomElement = function () {
            return this._viewport.dom;
        };

        EditorImpl.prototype.resize = function () {
            this._editor.signals.windowResize.dispatch();
        };

        EditorImpl.prototype.clearScene = function () {
            var objects = this._scene.getInternal().children;

            while ( objects.length > 0 ) {
                this._editor.removeObject( objects[ 0 ] );
            }
        };

        EditorImpl.prototype.notifySelectedNodeUpdated = function () {
            this._editor.signals.objectChanged.dispatch(this._editor.selected);

        };

        function create(parameters) {
            return new EditorImpl(parameters);
        }

        LANA3D.Editor.create = create;

    })(LANA3D.Three || (LANA3D.Three = {}));
}) (LANA3D || (LANA3D = {}));
